import React from 'react';
import { usePlansService } from 'nekst-api';
import { AsyncMultiSelectDropdown, BaseInputProps } from 'ui-builder';

export interface PlansMultiDropdownProps extends BaseInputProps<number[]> {
  exceptPlansIds?: number[];
  showGlobal?: boolean
}

export function PlansMultiDropdown(
  props: PlansMultiDropdownProps
) {
  const plansService = usePlansService();

  return (
    <AsyncMultiSelectDropdown
      {...props}
      loadOptionsFunc={async () => {
        let plans = await plansService.getAllTeamPlans();

        if (props.exceptPlansIds) {
          plans = plans.filter(
            (plan) => !props.exceptPlansIds!.includes(plan.id),
          );
        }

        if (!props.showGlobal) {
          plans = plans.filter(
            (plan) => !plan.isGlobal,
          );
        }


        return plans.map(
          (plan) => ({
            value: plan.id,
            label: plan.name,
          }),
        );
      }}
    />
  );
}
